angular.module('zc.zenclerkS')
  .component('zcsCampaignEdit', {
    templateUrl: '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit.html',
    bindings: {
      project: '<',
      campaign: '<'
    },
    controller: ZcsCampaignEditController
  });

ZcsCampaignEditController.$inject = ['$filter', '$scope', '$state', '$uibModal', '$translate', 'Campaign', 'Template', 'ZcsCampaign', 'ZcsCampaignName', 'ZcsIncentive', 'ZcsSegment', 'ZcsOemService'];
function ZcsCampaignEditController($filter, $scope, $state, $uibModal, $translate, Campaign, Template, ZcsCampaign, ZcsCampaignName, ZcsIncentive, ZcsSegment, ZcsOemService) {
  const vm = this;
  let templates = [];
  this.$onInit = () => {
    /* variables */
    vm.estimatedCv = ZcsSegment.estimatedCv;
    vm.incentive = vm.campaign.incentives[0] || vm.campaign.incentive_draft;

    /* actions */
    vm.isEnabledStep = isEnabledStep;
    vm.isPreviousStep = isPreviousStep;
    vm.isLastStep = isLastStep;
    vm.isScheduleValid = isScheduleValid;
    vm.areAllStepsValid = areAllStepsValid;
    vm.isModifiedSchedule = isModifiedSchedule;
    vm.getSaveButtonText = getSaveButtonText;
    vm.saveButtonClicked = saveButtonClicked;
    vm.canBeLaunched = canBeLaunched;
    vm.goToStep = goToStep;
    vm.exit = exit;
    vm.existingCouponCodes = [];
    vm.isCopy = isCopy;
    vm.getStepClass = getStepClass;
    vm.isCouponCodeInUse = isCouponCodeInUse;
    vm.isAllowedToCreate = () => ZcsCampaign.isAllowedToCreate(vm.project);
    vm.getTooltipMessage = () => ZcsCampaign.getTooltipMessage(vm.project);

    /* oem */
    $scope.$watch(function() {
      return ZcsOemService.get();
    }, isOem);

    function isOem(oemService) {
      if(oemService === 'makerepeater') {
        vm.isOem = true;
        if(vm.project.shopping_cart_asp === 'makeshop') {
          vm.isIntegratedWithMakeshop = (vm.campaign.status === 'incomplete' || vm.incentive.is_integrated_with_makeshop);
        } else {
          vm.isIntegratedWithMakeshop = false;
        }
      } else {
        vm.isOem = false;
        vm.isIntegratedWithMakeshop = false;
      }
    }

    /* steps */
    vm.steps = {
      items: [
        {
          name: 'segment',
          label: $translate.instant('sites.campaigns.edit.campaignEdit.segment'),
          route: 'zenclerkS.project.campaign.edit.segment',
          class: '',
          requiredProperty: undefined,
        },
        {
          name: 'coupon',
          label: $translate.instant('sites.campaigns.edit.campaignEdit.coupon'),
          route: 'zenclerkS.project.campaign.edit.coupon',
          class: '',
          requiredProperty: 'segment_id',
        },
        {
          name: 'design',
          label: $translate.instant('sites.campaigns.edit.campaignEdit.design'),
          route: 'zenclerkS.project.campaign.edit.design',
          class: '',
          requiredProperty: campaign => {
            if(!isSegmentSet(campaign)) {
              return false;
            } else if(!isIncentiveSet(campaign)) {
              return false;
            }
            return true;
          }
        },
        {
          name: 'delivery',
          label: $translate.instant('sites.campaigns.edit.campaignEdit.deliveryPlan'),
          route: 'zenclerkS.project.campaign.edit.delivery',
          class: '',
          requiredProperty: campaign => {
            if(!isSegmentSet(campaign)) {
              return false;
            } else if(!isIncentiveSet(campaign)) {
              return false;
            } else if(!campaign.template_type) {
              return false;
            }
            return true;
          }
        },
        {
          name: 'schedule',
          label: $translate.instant('sites.campaigns.edit.campaignEdit.schedule'),
          route: 'zenclerkS.project.campaign.edit.schedule',
          class: '',
          requiredProperty: 'timing',
        },
        {
          name: 'confirm',
          label: $translate.instant('sites.campaigns.edit.campaignEdit.confirm'),
          route: 'zenclerkS.project.campaign.edit.confirm',
          class: '',
          requiredProperty: campaign => {
            if(isScheduleValid()) {
              return true;
            }
            return false;
          }
        }
      ]
    };

    getExistingCouponCodes();

    init();

    $scope.$on('$viewContentLoaded', function() {
      refreshStepsStates();
    });

  };


  /* functions */

  function init() {
    // forward to segment if accessed directly
    if($state.current.name === 'zenclerkS.project.campaign.edit') {
      $state.go('zenclerkS.project.campaign.edit.segment');
    } else if(vm.steps.current && !isEnabledStep(vm.steps.current)) {
      $state.go(getStepFromIndex(vm.steps.previous).name);
    }

    // set but do not overwrite in case of existing campaign
    if(vm.campaign.id === 'new') {
      vm.campaign.campaign_device = 'devicefree';
      vm.campaign.campaign_type = 'Coupon';
    }

    Template.all(vm.project.id).then(res => {
      templates = res;
      $scope.$watch('$ctrl.campaign.template_type', chooseTemplate);
    });

    // in case of editing, set the initial segment
    if(vm.campaign.segment_id) {
      ZcsSegment.get(vm.project.id, vm.campaign.segment_id).then(segment => {
        vm.campaign.segment = segment;
      });
    }

    if(vm.campaign.id !== 'new') {
      vm.campaign.timing = angular.fromJson(vm.campaign.memo);
    }
  }

  function isIncentiveSet(campaign) {
    const incentive = _.get(campaign, 'incentives[0]', campaign.incentive_draft);
    if(incentive.has_price_limit && !incentive.minimum_price) {
      return false;
    } else if(!incentive.coupon_code) {
      return false;
    }
    return true;
  }

  function isSegmentSet(campaign) {
    if(!campaign.segment) {
      return false;
    }
    return true;
  }

  function getExistingCouponCodes() {
    ZcsIncentive.all(vm.project.id)
      .then(incentives => {
        const existingCouponCodes = _.chain(incentives)
        // reject self
          .reject(d => vm.campaign.incentives.length > 0 && d.id === vm.campaign.incentives[0].id)
          .reject(d => {
            if(vm.project.is_oem) {
            // do allow any duplicate coupon_code when MR
              return false;
            }
            // reject only active campaigns if not makerepeater (coupon_codes with already ended/terminated campaigns will work)
            return _.filter(d.campaigns, isCampaignActive).length === 0;
          })
          .map(d => d.coupon_code)
          .uniq()
          .value();
        // concat so that the reference does not change
        vm.existingCouponCodes = existingCouponCodes;
      });
  }

  function isCouponCodeInUse() {
    return vm.existingCouponCodes.indexOf(vm.incentive.coupon_code) >= 0;
  }

  function isCampaignActive(campaign) {
    return _.includes(['activated', 'blocked'], campaign.status) &&
      (moment(campaign.end_at).isAfter(moment()));
  }

  function isScheduleValid() {
    if(!vm.incentive.is_infinite &&
        (!_.get(vm.campaign, 'start_at_obj.date') ||
        !_.isNumber(_.get(vm.campaign, 'start_at_obj.time')) ||
        !_.get(vm.campaign, 'end_at_obj.date') ||
        !_.isNumber(_.get(vm.campaign, 'end_at_obj.time')))) {
      return false;
    }

    if(vm.incentive.is_infinite &&
      !_.get(vm.campaign, 'start_at_obj.date') ||
      !_.isNumber(_.get(vm.campaign, 'start_at_obj.time'))) {
      return false;
    }

    if(vm.campaign.status === 'incomplete' &&
        moment().startOf('day').valueOf() > vm.campaign.start_at_obj.date) {
      return false;
    }

    if(!vm.incentive.is_infinite &&
        vm.campaign.start_at_obj.date > vm.campaign.end_at_obj.date) {
      return false;
    }

    return true;
  }

  function isModifiedSchedule() {
    return moment(vm.campaign.end_at).startOf('day').valueOf() !== vm.campaign.end_at_obj.date;
  }

  function isEnabledStep(index) {
    if(isCopy(vm.campaign)) {
      return true;
    }

    let step = getStepFromIndex(index);
    if(step && step.requiredProperty) {
      let prop;
      if(_.isFunction(step.requiredProperty)) {
        prop = step.requiredProperty(vm.campaign);

        // in case of function, returning false or true is correct
        if(!prop) {
          return false;
        }
      } else {
        prop = _.get(vm.campaign, step.requiredProperty);

        // in case of value, false is also counted
        if(prop === null || angular.isUndefined(prop)) {
          return false;
        }
      }

    }
    return true;
  }

  function refreshStepsStates(step) {
    let stepName;
    if(step) {
      stepName = step.route;
    } else {
      stepName = $state.current.name;
    }

    vm.steps.current = _.findIndex(vm.steps.items, { route: stepName });
    vm.steps.previous = vm.steps.current - 1;

    if(vm.steps.current === 0) { // is first step?
      vm.steps.first = true;
      vm.steps.previous = vm.steps.current;
    } else {
      vm.steps.first = false;
      vm.steps.previous = vm.steps.current - 1;
    }

    if(vm.steps.current === vm.steps.items.length - 1) { // is last step?
      vm.steps.last = true;
      vm.steps.next = vm.steps.current;
    } else {
      vm.steps.last = false;
      vm.steps.next = vm.steps.current + 1;
    }
  }

  function getStepFromIndex(index) {
    return vm.steps.items[index];
  }

  /* Used to add css class that helps styling */
  function isPreviousStep() {
    let activeStateIndex = _.findIndex(vm.steps.items, { route: $state.current.name });
    return vm.steps.current < activeStateIndex;
  }

  function saveButtonClicked() {
    if(!canBeLaunched() || !ZcsCampaign.isAllowedToCreate(vm.project)) {
      return false;
    }

    if(isNewCampaign()) {
      openLaunchModal();
    } else {
      ZcsCampaign.save(vm.campaign, vm.project)
        .then(res => {
          if(vm.campaign.status === 'incomplete') {
            $state.go('zenclerkS.project.campaigns.draft', { apikey: vm.project.apikey });
          } else {
            $state.go('zenclerkS.project.campaigns.active', { apikey: vm.project.apikey });
          }
        });
    }
    return;
  }

  function goToStep(index, action) {
    if(index === vm.steps.current && action === 'stepper') {
      return;
    }

    if(!isEnabledStep(index)) {
      return;
    }

    const stepNext = getStepFromIndex(index);

    // If we are in a state that's before aiState, and have selected the mail only segment,
    // reset the timing (and memo which has timing stored in it)
    const aiStateIndex = _.findIndex(vm.steps.items, { route: 'zenclerkS.project.campaign.edit.delivery' });
    if(vm.steps.current < aiStateIndex && _.get(vm.campaign, 'segment.name') === 'zcs_segment_mail_only') {
      vm.campaign.timing = undefined;
      vm.campaign.memo = undefined;
    }

    $state.go(stepNext.route, { apikey: vm.project.apikey, campaignId: vm.campaign.id });

    refreshStepsStates(stepNext);
  }

  function isLastStep() {
    if(vm.steps.last) {
      return true;
    }
    return false;
  }

  function canBeLaunched() {
    // no segment set
    if(!vm.campaign.segment_id) {
      return false;
    }

    // no coupon code
    if(!vm.incentive.coupon_code) {
      return false;
    }

    // duplicate coupon code
    if(vm.existingCouponCodes.indexOf(vm.incentive.coupon_code) >= 0) {
      return false;
    }

    // no timing set
    if(!vm.campaign.timing) {
      return false;
    }

    // check schedule
    if(!isScheduleValid()) {
      return false;
    }

    // publish limit reached
    if(vm.project.is_publish_limit_reached) {
      return false;
    }

    return true;
  }

  function areAllStepsValid() {
    // Copy can go to each step
    if(isCopy(vm.campaign)) {
      return true;
    }

    if(!canBeLaunched()) {
      return false;
    }

    return true;
  }


  function getSaveButtonText() {
    if(isNewCampaign()) {
      return $translate.instant('sites.campaigns.edit.campaignEdit.deliver');
    }
    return $translate.instant('sites.campaigns.edit.campaignEdit.save');
  }

  function getStepClass($index) {
    return {
      active: $index === vm.steps.current,
      disabled: !vm.isEnabledStep($index) && !vm.isCopy(vm.campaign),
      'before-active': vm.isPreviousStep($index),
      'needs-action': vm.isCopy(vm.campaign) && (
        ($index === 1 && !vm.campaign.incentive_draft.coupon_code) ||
        ($index === 4 && (!vm.campaign.start_at_obj.date || !vm.campaign.end_at_obj.date))
      )
    };
  }


  function isNewCampaign() {
    if(vm.campaign.current_status === 'active' || vm.campaign.current_status === 'pending') {
      return false;
    }
    return true;
  }

  function chooseTemplate(newval, oldval) {
    if(!newval) return;
    vm.campaign.template = _.find(templates, d => d.name === newval);
  }

  function isCopy(campaign) {
    if(campaign.name.startsWith($translate.instant('sites.campaigns.edit.campaignEdit.copyInParenthesis'))) {
      return true;
    }
    return false;
  }

  function exit() {
    if(vm.campaign.id === 'new' && angular.isUndefined(vm.campaign.segment)) { // exit directly if camapaign have no setting
      $state.go('zenclerkS.project.campaigns', {apikey: vm.project.apikey});
    } else {
      $uibModal.open({
        templateUrl: '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit_modal_exit.html',
        controller: 'ZcsCampaignEditModalExitController as $ctrl',
        size: 'sm',
        resolve: {
          campaign: vm.campaign,
          project: vm.project
        }
      });
    }
  }

  function openLaunchModal() {
    $uibModal.open({
      templateUrl: '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit_modal_launch.html',
      size: 'sm',
      controller: 'ZcsCampaignEditModalLaunchController as $ctrl',
      resolve: {
        campaign: vm.campaign,
        project: vm.project,
        isIntegratedWithMakeshop: vm.isIntegratedWithMakeshop
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/campaigns/edit/campaign_edit.js